// extracted by mini-css-extract-plugin
export default {"header":"Navbar_header__hzCG7","blackBackground":"Navbar_blackBackground__77QTf"};